import React from 'react';
import styled from '@emotion/styled';
import { Config, StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

type Props = {
  image: string;
  alt: string;
};

const Img = styled.img({
  height: '100%',
  width: '100%',
  objectFit: 'contain',

  [mqBreakpoints.tablet]: {
    padding: `0 ${pxToRem(96)}`,
  },

  [mqBreakpoints.desktop]: {
    padding: 'initial',
  },
});

const ImageContainer = styled.div({
  flex: '1 1 0',
  height: pxToRem(256),
  maxHeight: pxToRem(256),
  marginBottom: pxToRem(24),

  [mqBreakpoints.desktop]: {
    height: pxToRem(320),
    maxHeight: pxToRem(320),
  },
});

export const TileImage: React.FC<Props> = ({ image, alt = 'Marketplace' }) => {
  return (
    <ImageContainer data-testid='mp-tile-image'>
      <Img src={`${Config.get('image_cdn_base_url')}/${image}`} alt={alt} />
    </ImageContainer>
  );
};
